import { AfterViewInit, Component, inject, QueryList, ViewChild, ViewChildren } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { Capacitor } from "@capacitor/core";
import { IonRouterOutlet } from "@ionic/angular";

import { AccountService } from "../../lib/account.service";
import { Modal } from "../../lib/modal";
import { NavigationService } from "../../lib/navigation.service";
import { AccountModalComponent } from "../account-modal/account-modal.component";
import { LoginModalComponent } from "../login-modal/login-modal.component";

@Component({
  selector: "app-base-toolbar",
  templateUrl: "./base-toolbar.component.html",
  styleUrls: ["./base-toolbar.component.css"],
})
export class BaseToolbarComponent implements AfterViewInit {
  public account = inject(AccountService);
  public nav = inject(NavigationService);
  public router = inject(Router);
  public route = inject(ActivatedRoute);

  @ViewChild(BaseToolbarComponent) el!: HTMLElement;
  @ViewChild(LoginModalComponent) loginModal!: LoginModalComponent;
  @ViewChild(AccountModalComponent) accountModal!: AccountModalComponent;
  //@ViewChild(IonRouterOutlet) routerOutlet!: IonRouterOutlet;
  routerOutlet = inject(IonRouterOutlet);

  @ViewChildren("loginModal,accountModal,historyModal")
  modals?: QueryList<Modal>;

  ngAfterViewInit() {
    this.nav.backButtonHandler = this.back.bind(this);
  }

  async back() {
    // Check open popup modals
    if (this.modals) {
      for (const i of this.modals) {
        if (i.isOpen) {
          await i.back();
          return;
        }
      }
    }

    // Try currently open page
    if (this.nav.pageBackFile && this.nav.pageBack && location.pathname.startsWith(this.nav.pageBackFile)) {
      const fn = this.nav.pageBack;
      this.nav.pageBack = undefined;
      this.nav.pageBackFile = undefined;
      if (fn()) {
        return;
      }
    }

    // Delegate to nav back
    await this.nav.back();
  }

  canGoBack() {
    // Check open popup modals
    if (this.modals) {
      for (const i of this.modals) {
        if (i.isOpen) {
          return true;
        }
      }
    }

    if (window.location.pathname == "/home" || window.location.pathname == "/") {
      // Can't navigate any further than home
      return false;
    }

    // Try currently open page
    if (this.nav.pageBackFile && this.nav.pageBack && location.pathname.startsWith(this.nav.pageBackFile)) {
      return true;
    }

    if (Capacitor.getPlatform() === "web") {
      // Web can freely reload the page, destroying all JS-based stacks
      return true;
    }

    return false;
  }
}
